import ENDPOINTS from 'api/endpoints';
import { doDelete, doGet, doPost } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import type { CreatePatRequest, Pat } from './types';

export const getPats = () => {
  return doGet<Pat[]>(ENDPOINTS.PATS, LOGGER_TYPE.JUPITER, { version: 'v2' });
};

export const createPat = (body: CreatePatRequest) => {
  return doPost<Pat>(ENDPOINTS.PATS, LOGGER_TYPE.JUPITER, body, {
    version: 'v2',
  });
};

export const deletePat = (key: string) => {
  return doDelete<void>(
    ENDPOINTS.PATS,
    LOGGER_TYPE.JUPITER,
    { key },
    {
      version: 'v2',
    },
  );
};
